// extracted by mini-css-extract-plugin
export default {"linkGuide":"LinkGuide_linkGuide__OdSof"};